// extracted by mini-css-extract-plugin
export default {"notFoundContainer":"NotFound_notFoundContainer__7-5OD","title":"NotFound_title__htZJO","message":"NotFound_message__YdKU+","homeLink":"NotFound_homeLink__P-EkH"};